
import React, { useEffect, useState, useRef } from 'react';
import { formatTime, isMobile } from '../util';
import { AssistWalker, Height, ShuffleOn } from '@mui/icons-material';
import { Shuffle } from '@mui/icons-material';
import { useLongPress } from 'use-long-press';
import { useSwipeable } from 'react-swipeable';
import useAppStore from '../AppStore';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import api from '../Api';

const ArtistRow = ({ artist, onButtonClick, onContextMenu, liked, showLiked, id, draggable, source, shuffleButton, index, playlist, onClick, onDoubleClick, bulbOn, onBulbClick, selected, bulbCheckOn, onBulbCheckClick, icon, onLongPress, onSwipedLeft, onDrop, onSwipedRight }) => {

    const { library, setLibrary, deleteFromLibrary, setSelectedLibraryIndex, selectedLibraryIndex, dragTrack, setDragTrack, setDragSourceIndex, setDragSource, dragSource } = useAppStore();
    
    const swipeHandler = useSwipeable({
        onSwipedLeft: () => { if (onSwipedLeft) onSwipedLeft() },
        onSwipedRight: () => { if (onSwipedRight) onSwipedRight() },
        // onSwipedUp: () => alert('Swiped up!'),
        // onSwipedDown: () => alert('Swiped down!'),
        preventDefaultTouchmoveEvent: true,
        trackMouse: true
    });

    const longPressHandler = useLongPress(
        (e) => {
            e.preventDefault();      // 👈 blocks the synthetic click after touchend
            e.stopPropagation();     // 👈 prevents bubbling

            if (isMobile() && onLongPress) {
                onLongPress(playlist, bulbOn);
            }
        },
        {
            // extra safety: cancel synthetic click entirely
            captureEvent: true,       // ensures we get the raw event
            cancelOnMovement: true,   // prevents misfires when finger moves
        }
    );

    const [isDragOver, setIsDragOver] = useState(false)
    const dragCounter = useRef(0);

    return (

        <div
            onContextMenu={(e) => { }} id={id} {...longPressHandler()} {...swipeHandler} onClick={() => { onClick && onClick() }} onDoubleClick={() => onDoubleClick && onDoubleClick()}

            className={`${selected ? 'item-row-selected' : 'item-row'} ${isDragOver ? 'drag-over' : ''}`}
            style={{ borderBottom: "none" }}
        >



            <div class="artist-row-grid">
                <div class="artist-row-grid__image">
                    <img src={artist.images?.[2]?.url || artist.images?.[0]?.url} alt="Artist image" />
                </div>

                <div class="artist-row-grid__content">
                    <div class="artist-row-grid__top">
                        {artist.name}
                    </div>
                    <div class="artist-row-grid__bottom">
                        <button class="artist-row-grid__bottom-button" onClick={() => onButtonClick("info", artist)} >Info</button>
                        <button class="artist-row-grid__bottom-button" onClick={() => onButtonClick("albums", artist)} >Albums</button>
                        <button class="artist-row-grid__bottom-button" onClick={() => onButtonClick("topTracks", artist)} >Top tracks</button>
                    </div>
                </div>
            </div>


        </div>
    )
}
export default ArtistRow;